import { Layers } from "lucide-react"

interface CardsIndexProps {
  currentCardIndexInTheDeck: number
  totalCardsAmount: number
}

const CardsIndex: React.FC<CardsIndexProps> = ({ currentCardIndexInTheDeck, totalCardsAmount }) => {
  return (
    <div className="flex items-center justify-center gap-2 rounded-[99px] bg-orange-100 px-2 py-1">
      <p className="text-sm font-medium text-gray-600">
        {currentCardIndexInTheDeck}/{totalCardsAmount}
      </p>

      <Layers className="text-orange-500" />
    </div>
  )
}

export default CardsIndex
